export function calculate_total_lost_returned() {

  let all_line = document.querySelectorAll("#clientPurchase_form_clientPurchase_vs_lost .line");
  let input_total_lost = document.querySelector("#clientPurchase_form_total_lost input");
  let input_total_returned = document.querySelector("#clientPurchase_form_total_returned input");
  let input_total_general = document.querySelector("#clientPurchase_form_general_lost input");
  let total_lost = 0;
  let total_returned = 0;
  let total_general = 0;

  if (all_line != undefined && all_line != null) {
    all_line.forEach(function (element) {
      let input_price = element.querySelector('.lost_price input');
      let price_value = (input_price.value == "" || parseFloat(input_price.value) == NaN || parseFloat(input_price.value) == 0) ? 0 : parseFloat(input_price.value);
      let input_return = element.querySelector('.return_item input');

      if (input_return.checked) {
        total_returned = total_returned + price_value;
      } else {
        total_lost = total_lost + price_value;
      }

    });
  }

  total_general = total_lost + total_returned;
  input_total_lost.value = `${parseFloat(total_lost).toFixed(2)}`;
  input_total_returned.value = `${parseFloat(total_returned).toFixed(2)}`;
  input_total_general.value = `${parseFloat(total_general).toFixed(2)}`;

}